import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import reportService from '../services/reportService';

// 8 sep 2026 (pedido de Augusto: "los informes aparecen en dolares,
// deberia dar la opcion de dolares o soles, pero siempre mostrarlo en la
// moneda de donde es el usuario"): los 3 thunks de abajo ahora reciben
// moneda/tasaManual (ver Reports.js) y se los pasan a reportService --
// antes fetchYearlyReport/fetchCategoryReport recibian el valor
// primitivo directo (year / category) como unico argumento; ahora los 3
// reciben un objeto, igual que ya hacia fetchMonthlyReport. No hay otros
// llamadores de estos 3 thunks en el codebase (confirmado por grep), asi
// que este cambio de firma no rompe nada mas.
export const fetchMonthlyReport = createAsyncThunk(
  'reports/fetchMonthly',
  async ({ year, month, moneda, tasaManual }, { rejectWithValue }) => {
    try {
      const response = await reportService.getMonthlyReport(year, month, moneda, tasaManual);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchYearlyReport = createAsyncThunk(
  'reports/fetchYearly',
  async ({ year, moneda, tasaManual }, { rejectWithValue }) => {
    try {
      const response = await reportService.getYearlyReport(year, moneda, tasaManual);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchCategoryReport = createAsyncThunk(
  'reports/fetchCategory',
  async ({ category, year, month, moneda, tasaManual }, { rejectWithValue }) => {
    try {
      const response = await reportService.getCategoryReport(category, year, month, moneda, tasaManual);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  monthly: null,
  yearly: null,
  category: null,
  loading: false,
  error: null,
};

const reportSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Monthly report
    builder
      .addCase(fetchMonthlyReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMonthlyReport.fulfilled, (state, action) => {
        state.loading = false;
        state.monthly = action.payload;
      })
      .addCase(fetchMonthlyReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // Yearly report
    builder
      .addCase(fetchYearlyReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchYearlyReport.fulfilled, (state, action) => {
        state.loading = false;
        state.yearly = action.payload;
      })
      .addCase(fetchYearlyReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // Category report
    builder
      .addCase(fetchCategoryReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategoryReport.fulfilled, (state, action) => {
        state.loading = false;
        state.category = action.payload;
      })
      .addCase(fetchCategoryReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = reportSlice.actions;
export default reportSlice.reducer;
